// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DatePicker_wrapper__1wgUc","notification":"DatePicker_notification__1mNRG"};